import React from 'react';
import PropTypes from 'prop-types';
import popup from '../../../popup';
import { get } from 'lodash';
import './style.scss';
import '~/assets/css/fitness-globals.scss';
import { LoadingIcon } from '~/assets/svg';
import { getToken } from '~/redux/user/tokens';
import { axiosWithKey } from '~/axios';
import { userLanguageSelector } from '~/tools/localization';
import { getSubscriptionPlans } from '~/redux/user/subscription';
import Background from './Rectangle.png';
import {
  pushViewPlansEvent,
  pushSelectPlanEvent
} from '~/services/analyticsService';
import { StripeJS } from '~/views/Popup/views/CreateSubscription/Billing/StripeCCForm/StripeJS'

class ChooseAPlan extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      plans: [],
      loading: false
    };
  }

  async componentDidMount() {
    await StripeJS()
    getSubscriptionPlans().then(plans => {
      //Only display 2 plans max
      if (plans.length > 2) {
        plans = plans.slice(0, 2);
      }
      this.setState({ ...this.state, plans: plans, loading: false });
      pushViewPlansEvent(plans);
    });
    if (!this.state.metadataMap) {
      this.fetchPageData();
    }
    this.setState({ loading: true });
  }

  handleSubscriptionClick(plan) {
    pushSelectPlanEvent(plan);
    this.props.onClose();
    popup.fitnessCheckout({
      showCloseButton: false,
      selectedPlan: plan,
      fields: this.state.metadataMap
    });
  }

  fetchPageData = () => {
    getToken(token => {
      return axiosWithKey({
        method: 'GET',
        url: `${window.settings.apiBaseUrlCached || window.settings.apiBaseUrl}/content/pages?path=/subscribe&languageCode=${userLanguageSelector()}&includeContent=true`,
        headers: { Authorization: token }
      })
        .then(res => {
          const response = res.data.modules[0].metadataMap;
          this.setState({ metadataMap: response, loading: false });
        })
        .catch();
    });
  };

  //Hack to handle using modal on /viewplans
  handleClose() {
    if (window.location.pathname === '/viewplans') {
      window.location.href = '/home';
    }
    this.props.onClose();
  }

  renderPlan(plan) {
    //Hard coding this for now
    if (plan.renewalCycleType === 'YEAR') {
      const { planDetails = [] } = plan;
      const featureDetails = (planDetails.length > 0 && planDetails[0].featureDetails) ? planDetails[0].featureDetails : [];
      const priceSrings = planDetails[0].recurringPaymentAmount.toString().split('.');
      return (
        <div className="plan" key={plan.id}>
          <h3>
            {plan.name} <span className="red">{plan.description}</span>
          </h3>
          <div className="price">
            {priceSrings[0]}
            <span className="cents">{priceSrings[1]}</span>
          </div>
          <p className="trial-text red">
            {featureDetails.length > 0 && featureDetails[0].textToDisplay}
          </p>
          <p className="small-text">
            {featureDetails.length > 1  && featureDetails[1].textToDisplay}
          </p>
          <button
            className="primary-button black"
            onClick={() => this.handleSubscriptionClick(plan)}
          >
            {planDetails[0].callToAction}
          </button>
        </div>
      );
    } else if (plan.renewalCycleType === 'MONTH') {
      const { planDetails = [] } = plan;
      const featureDetails = (planDetails.length > 0 && planDetails[0].featureDetails) ? planDetails[0].featureDetails : [];
      const priceSrings = planDetails[0].recurringPaymentAmount.toString().split('.');
      return (
        <div className="plan" key={plan.id}>
          <h3>
            {plan.name} <span className="red placeHolder">{plan.description || 'PLACEHOLDER'}</span>
          </h3>
          <div className="price">
            {priceSrings[0]}
            <span className="cents">{priceSrings[1]}</span>
          </div>
          <p className="trial-text red placeHolder">
            PLACEHOLDER
          </p>
          <p className="small-text">
            {featureDetails.length > 0 && featureDetails[0].textToDisplay}
          </p>
          <button
            className="primary-button black"
            onClick={() => this.handleSubscriptionClick(plan)}
          >
            {planDetails[0].callToAction}
          </button>
        </div>
      );
    }
  }

  render() {
    // console.log(this.state.plans);
    const yearlyPlan = this.state.plans.filter(e => e.renewalCycleType === 'YEAR')[0];
    const monthlyPlan = this.state.plans.filter(e => e.renewalCycleType === 'MONTH')[0];

    return (
      <div
        className="choose-plan fitness-modal"
        style={{ backgroundImage: `url(${Background})` }}
      >
        <div className="close-button" onClick={this.handleClose.bind(this)}>
          <i className="ion-ios-close-empty" />
        </div>
        <img
          className="logo-image"
          src={get(window.settings, 'images.desktopLogo')}
          alt="Logo"
        />
        {!this.state.loading ? (
          <div>
            <p className="subheader">ALL ACCESS. ANYTIME, ANY DEVICE.</p>
            {/* <h2>Join now to lock-in <br/> our introductory price!</h2> */}
            <div className="offer-container">
              {this.state.plans.map(plan => this.renderPlan(plan))}
            </div>
            {/* <p className="offer-end">Introductory Pricing Ends May 1st!</p> */}
            {this.state.plans.length >= 2 && (
              <p className="legal-text">
                This subscription automatically renews for $
                {monthlyPlan.planDetails[0].recurringPaymentAmount} per
                month, or annually at $
                {yearlyPlan.planDetails[0].recurringPaymentAmount}{' '}
                after the {yearlyPlan.planDetails[0].featureDetails[0].textToDisplay.toLowerCase()}. You can cancel anytime. By signing
                up, you agree to NEOU's{' '}
                <a href="/tos">Terms of Service</a>.
              </p>
            )}
          </div>
        ) : (
          <LoadingIcon />
        )}
      </div>
    );
  }
}

ChooseAPlan.propTypes = {
  onClose: PropTypes.func
};

export default ChooseAPlan;
